<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title v-if="student">{{ student.full_name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-tabs right background-color="blur">
          <v-tab :to="{name: 'Student info', params: $route.params}">Info</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Student edit', params: $route.params}">Edit</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Student study groups', params: $route.params}">Study groups</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Student limits', params: $route.params}">Limits</v-tab>
          <v-tab :to="{name: 'Student sessions', params: $route.params}">Sessions</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Student events', params: $route.params}">Events</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Student invoices', params: $route.params}">Invoices</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <router-view :student="student" @loadStudent="loadData"></router-view>
  </section>
</template>

<script>
export default {
  data: () => ({
    student: null
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.student = await this.axios.get(`api/students/${this.$route.params.student_id}`).then(({data}) => data.data)
    }
  }
}
</script>